import { Button, Tooltip, useCopyToClipboard } from "@alch/ui";
import { useEffect } from "react";
import type { Control } from "react-hook-form";
import { useWatch } from "react-hook-form";

import { analyticsEvent, EventPrefix } from "@util/analytics";

import { LinkSimpleIcon } from "@components/ui/icons/phosphor";
import { preserveQueryParams } from "@features/common/ViewAsPreservingLink";
import { useHistory } from "react-router-dom";
import type { ComposerFormState } from "./lib/form.js";
import { buildShareUrl } from "./lib/sharing.js";

interface ComposerShareButtonProps {
  control: Control<ComposerFormState>;
  baseUrl: string;
}

const ComposerShareButton = ({
  control,
  baseUrl,
}: ComposerShareButtonProps) => {
  const { isCopiedToClipboard, handleCopyToClipboard } = useCopyToClipboard();
  const history = useHistory();

  const formState = useWatch({ control }) as ComposerFormState;
  const shareUrl = buildShareUrl({ baseUrl, state: formState });

  const generateShortShareUrl = () => {
    analyticsEvent(`${EventPrefix.Sandbox}: Copied share url`);

    handleCopyToClipboard(shareUrl);
  };

  useEffect(() => {
    const { search } = preserveQueryParams(history.location, shareUrl);
    history.replace({ search });
  }, [shareUrl, history]);

  return (
    <Tooltip content="Copied" withArrow side="top" open={isCopiedToClipboard}>
      <Button
        leadingIcon={<LinkSimpleIcon />}
        intent="tertiary"
        onClick={generateShortShareUrl}
      >
        Share request
      </Button>
    </Tooltip>
  );
};

export default ComposerShareButton;
